import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../redux/UserActions";
import { Dialog, Transition } from "@headlessui/react";
import MultiSelectListBox from "./Helper/MultiSelectListBox";
import TimezoneSelect from "react-timezone-select";
import {
  ArrowDownIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  XIcon,
} from "@heroicons/react/solid";
import { ResponsivePie } from "@nivo/pie";

export default function CustomNotifications() {
  const userSelector = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [expandedNotification, setExpandedNotification] = useState("");

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    setNotifications([...userSelector.notifications].reverse());
  }, [userSelector.notifications]);

  useEffect(() => {
    dispatch(UserActions.organization({}));
    dispatch(UserActions.notifications({}));
  }, []);

  return (
    <>
      <div className="flex flex-col gap-y-4 p-4 w-full bg-gray-100">
        <input
          className="text-lg font-semibold p-2 bg-green-300 rounded-md"
          type="button"
          value="Create Notification"
          onClick={() => setIsCreateModalOpen(true)}
        />
        {notifications.map((notification) =>
          notification._id.$oid === expandedNotification ? (
            <div className="grid lg:grid-cols-4 grid-cols-1 gap-y-4 bg-white py-2 px-4 rounded-md">
              <FieldLabel name="Notification Body:" value={notification.body} />
              <FieldLabel
                name="Responses:"
                value={`${notification.replies?.length} / ${notification.reached}`}
              />
              <FieldLabel
                name="Expiration Date:"
                value={new Date(notification?.expireTime.$date).toString()}
              />
              <input
                type="button"
                className="w-full mb-auto mx-auto font-medium bg-green-300 rounded-md p-2"
                value="Remind"
                onClick={() => {
                  console.log(notification._id.$oid);
                  dispatch(
                    UserActions.remindNotification({
                      notification: notification._id.$oid,
                    })
                  );
                }}
              />
              {notification.replies?.length === 0 ? null : (
                <span className="w-full lg:col-span-4 col-span-1  grid lg:grid-cols-4 grid-cols-1">
                  <span className="h-48">
                    <ResponsivePie
                      data={[
                        {
                          id: "positive",
                          label: "Positive",
                          value: notification.replies.filter(
                            (reply) => reply.response === "positive"
                          ).length,
                          color: "#66BB6A",
                        },
                        {
                          id: "negative",
                          label: "Negative",
                          value: notification.replies.filter(
                            (reply) => reply.response === "negative"
                          ).length,
                          color: "#DF605D",
                        },
                        {
                          id: "neutral",
                          label: "Neutral",
                          value: notification.replies.filter(
                            (reply) => reply.response === "neutral"
                          ).length,
                          color: "#839098",
                        },
                      ]}
                      margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
                      innerRadius={0.5}
                      padAngle={2}
                      cornerRadius={5}
                      colors={{ datum: "data.color" }}
                      arcLinkLabelsSkipAngle={10}
                      arcLinkLabelsTextColor="#333333"
                      arcLinkLabelsThickness={2}
                      arcLinkLabelsColor={{ from: "color" }}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{
                        from: "color",
                        modifiers: [["darker", 2]],
                      }}
                      activeOuterRadiusOffset={15}
                      onClick={() => {
                        console.log(
                          notification.replies.filter(
                            (reply) => reply.response === "positive"
                          ).length
                        );
                      }}
                    />
                  </span>
                  {notification.anonymous ? (
                    <span className="flex w-full h-full items-center justify-center">
                      <label className="font-semibold text-xl">
                        Anonymous Notification
                      </label>
                    </span>
                  ) : (
                    <div className="flex flex-col max-h-lg p-2 col-span-3 overflow-y-auto gap-y-2">
                      {notification.replies.map((reply) => (
                        <span
                          className={
                            "bg-white rounded-r-md p-2 border-l-4 " +
                            (reply.response === "positive"
                              ? "border-green-500 bg-gray-200"
                              : reply.response === "negative"
                              ? "border-green-500 bg-gray-300"
                              : "border-green-500 bg-gray-300")
                          }
                        >
                          {reply.user.firstName + " " + reply.user.lastName}
                        </span>
                      ))}
                    </div>
                  )}
                </span>
              )}
              <ChevronUpIcon
                className=" lg:col-span-4 col-span-1 w-full h-8 text-gray-400"
                onClick={() => setExpandedNotification("")}
              />
            </div>
          ) : (
            <div className="grid lg:grid-cols-4 grid-cols-1 gap-y-4 bg-white py-2 px-4 rounded-md">
              <FieldLabel name="Notification Body:" value={notification.body} />
              <FieldLabel
                name="Responses:"
                value={`${notification.replies?.length} / ${notification.reached}`}
              />
              <FieldLabel
                name="Expiration Date:"
                value={new Date(notification?.expireTime.$date).toString()}
              />
              {notification.replies?.length === 0 ? (
                <input
                  type="button"
                  className="w-full mb-auto mx-auto font-medium bg-green-300 rounded-md p-2"
                  value="Remind"
                  onClick={() => {
                    console.log(notification._id.$oid);
                    dispatch(
                      UserActions.remindNotification({
                        notification: notification._id.$oid,
                      })
                    );
                  }}
                />
              ) : (
                <ChevronDownIcon
                  className="w-full h-8 text-gray-400"
                  onClick={() => setExpandedNotification(notification._id.$oid)}
                />
              )}
            </div>
          )
        )}
      </div>
      <CreateNotificationCard
        isOpen={isCreateModalOpen}
        setIsOpen={(e) => setIsCreateModalOpen(e)}
      />
    </>
  );
}

function FieldLabel(props) {
  return (
    <span className="flex flex-col">
      <label className="text-xs font-light">{props.name}</label>
      <label className="px-2 font-semibold ">{props.value}</label>
    </span>
  );
}

function CreateNotificationCard(props) {
  const userSelector = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [body, setBody] = useState("");
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [anonymous, setAnonymous] = useState(false);
  const [activity, setActivity] = useState([]);
  const [date, setDate] = useState("");
  const [timezone, setTimezone] = useState("");

  function createCustomNotification() {
    dispatch(
      UserActions.createNotification({
        notification: JSON.stringify({
          body,
          departments,
          locations,
          activity,
          anonymous,
          expireTime: new Date(date).toLocaleString("en-US", {
            timeZone: timezone?.value,
          }),
        }),
      })
    );
  }
  return (
    <Transition appear show={props.isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 h-screen w-screen"
        onClose={() => props.setIsOpen(false)}
      >
        <div className="min-h-screen  text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-20"
            leave="ease-in duration-200"
            leaveFrom="opacity-30"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <div className="flex w-screen h-screen items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="w-full max-w-3xl h-auto p-6 transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="flex items-center text-lg w-full justify-center text-center font-medium leading-6 text-gray-900"
                >
                  <XIcon
                    className="fixed left-4 h-8 w-8"
                    onClick={() => props.setIsOpen(false)}
                  />
                  Create a Notification
                </Dialog.Title>
                <div className="flex flex-col gap-y-1 mt-2">
                  <p className="text-sm text-gray-500">
                    Your notification will be sent out to everyone targeted by
                    the filters combined.
                  </p>
                  <hr className="my-2" />
                  <div className="grid grid-cols-3 gap-y-2 items-center">
                    <label className="w-full text-left">Body:</label>
                    <input
                      type="text"
                      className="col-span-2 border-1 border-gray-300 rounded-md bg-gray-100"
                      onChange={(e) => setBody(e.target.value)}
                    />
                    <label className="w-full text-left">Departments:</label>
                    <MultiSelectListBox
                      listboxClasses="col-span-2 border-gray-200"
                      label={"Test"}
                      options={userSelector.organization.departments}
                      handleSelected={(e) => setDepartments(e)}
                    />
                    <label className="w-full text-left">Locations:</label>
                    <MultiSelectListBox
                      listboxClasses="col-span-2 border-gray-200"
                      label={"Test"}
                      handleSelected={(e) => setLocations(e)}
                      options={userSelector.organization.locations}
                    />
                    <label className="w-full text-left">Activity:</label>
                    <MultiSelectListBox
                      listboxClasses="col-span-2 border-gray-200"
                      label={"Test"}
                      handleSelected={(e) => setActivity(e)}
                      options={[
                        "No Activity",
                        "Low",
                        "Medium",
                        "High",
                        "Daily",
                      ]}
                    />
                    <label className="w-full text-left">Anonymous:</label>
                    <input
                      type="checkbox"
                      onChange={(e) => setAnonymous(e.target.checked)}
                      className="col-span-2 border-1 border-gray-300 text-green-500 rounded-md bg-gray-100"
                    />
                  </div>
                  <label className="w-full text-left">Expiry Date:</label>
                  <input
                    type="datetime-local"
                    className="rounded border-gray-300"
                    onChange={(e) => setDate(e.target.value)}
                  />
                  <TimezoneSelect value={timezone} onChange={setTimezone} />
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2  font-medium text-black bg-green-300 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={() => createCustomNotification()}
                  >
                    Create Notification!
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
